<template>
<div>
  <div class="row content">
    <div class="col">
      <div class="q-card-title">{{$t('global.YieldJournal')}}</div>
    </div>
  </div>
  <div class="row content">
      <div class="col-3">
        <q-datetime v-model="dateFrom" type="date" :float-label="$t('global.DateFrom')" format="D.MMM.YYYY" />
      </div>
      <div class="col-1"></div>
      <div class="col-3">
        <q-datetime v-model="dateTo" type="date" :float-label="$t('global.DateTo')" format="D.MMM.YYYY" />
      </div>
       <div class="col-1"></div>
      <div class="col-4">
        <q-btn color="secondary" flat label="Excel Dashboard" @click="excel(1)" />
    </div>
    </div>
  <div class="content">
  <q-table
    :data="items"
    :columns="columns"
    row-key="IdYield"
    :dense=true
    selection="single"
    :selected.sync="selectedRows"
    :loading="loading"
    :pagination.sync="paginationControl" 
    >
    <template slot="top-selection" slot-scope="props" >
      
      <div>
        <q-btn color="secondary" flat :label="$t('global.Edit')" class="q-mr-sm" @click="editYield()" />
        <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteYield()" />
      </div>
    </template>  
  </q-table>
  </div>
  <q-dialog
    v-model="editDialog"
    stack-buttons
    prevent-close
  >
  <!-- This or use "title" prop on <q-dialog> -->
  <span slot="title">{{title}}</span>
  <div slot="body">
      <q-input v-model="comment" ref="comment" :float-label="$t('global.Comment')"/>
      <div class="row">
        <div class="col">
          <q-datetime v-model="yieldDate" type="date" :float-label="$t('global.DateFrom')" format="D.MMM.YYYY" />
        </div>
      </div>
      <div class="row">    
        <div class="col-5">          
        <q-input class="content" v-model="quantity" :stack-label="$t('global.Quantity')" type="number" :decimals="2" />
        </div>  
        <div class="col"></div>
        
        <br>
        <br>          
      </div>
  </div>

  <template slot="buttons" slot-scope="props">
    <q-btn color="primary" :label="$t('global.Save')" @click="saveYield()" />
    <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
  </template>
  </q-dialog>
</div>    
</template>

<script>
import { date } from 'quasar'
import axios from 'axios'
import qs from 'qs'
import {eventBus} from '../../main'
export default {
  name: 'YieldJournal',
  data: function () {
    return {
      dateFrom: date.startOfDate(Date.now(), 'month'),
      dateTo: date.addToDate(Date.now(), { days: 0 }),
      form: {
        SessionId: null,
      },
      idYield: null,
      comment: null,
      quantity: null,
      quality: null,
      yieldDate: null,
      editDialog: false,
      title: '',  
      loading: false,
      selectedRows: [],
      items:[],
      columns: [
      {
        name: 'YieldDate',
        required: true,
        label: this.$t('global.Date'),
        align: 'left',
        field: 'YieldDate',
        sortable: true,
        format: val => this.dateFormat(val)
      },

      {
        name: 'Product Group',
        required: true,
        label: this.$t('global.ProductGroup'),
        align: 'left',
        field: 'ProductGroup',
        sortable: true
      },
      {
        name: 'Product',
        required: true,
        label: this.$t('global.Product'),
        align: 'left',
        field: 'Product',
        sortable: true
      },
      {
        name: 'GeoRegion',
        required: true,
        label: this.$t('global.Field'),
        align: 'left',
        field: 'GeoRegion',
        sortable: true
      },
      {
        name: 'Quantity',
        required: true,
        label: this.$t('global.Quantity'),
        align: 'right',
        field: 'Quantity',
        sortable: true
      },
      {
        name: 'Comment',
        required: true,
        label: this.$t('global.Comment'),
        align: 'left',
        field: 'Comment',
        sortable: false
      },
      {
        name: 'FirstName',
        required: true,
        label: this.$t('global.NameFirst'),
        align: 'left',
        field: 'FirstName',
        sortable: true
      },
      {
        name: 'LastName',
        required: true,
        label: this.$t('global.Name'),
        align: 'left',
        field: 'LastName',
        sortable: true
      },
      ],
      columnHeaders: ['global.Date','global.Field','global.Quantity','global.Quality','global.Comment','global.NameFirst','global.Name'],
      paginationControl: { rowsPerPage: 15, page: 1 },
    }   

  },
  methods: {
    editYield () {
      var Yield = this.selectedRows[0]
      this.title = Yield.GeoRegion
      this.comment = Yield.Comment
      this.quantity = Yield.Quantity
      this.quality = Yield.Quality
      this.yieldDate = Yield.YieldDate
      this.idYield = Yield.IdYield
      this.editDialog = true
    },
    deleteYield () {
      var self = this
      this.$q.dialog({
        title: this.$t('global.DeleteEntry'),
        message: this.$t('global.DeleteEntryQuestion'),
        color: 'primary',
        ok: true, // takes i18n value, or String for "OK" button label
        cancel: true, // takes i18n value, or String for "Cancel" button label
        preventClose: true,
        noBackdropDismiss: false, // gets set to "true" automatically if preventClose is "true"
        noEscDismiss: false, // gets set to "true" automatically if preventClose is "true"
        stackButtons: false,
        position: 'top',        
      })
      .then(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "deleteYield"
        this.form.IdYield = self.selectedRows[0].IdYield
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
              this.loadData()
              self.selectedRows = []
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {
          this.$q.notify('Something Wrong.')
          console.log(e);
        })  
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    saveYield () { 
      this.editDialog = false
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "saveYield"
      this.form.IdYield = this.idYield
      this.form.comment = this.comment
      this.form.quantity = this.quantity
      //this.form.quality = this.quality
      this.form.quality = 0
      this.form.yieldDate = this.yieldDate
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          if(response.status == 200){ 
            this.$q.notify({ message: this.$t('global.WorkChanged'), type: 'positive' })
            this.loadData()
            self.selectedRows = []
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })  
    },


    loadData(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getYieldByCustomer"
      this.form.dateFrom = this.dateFrom
      this.form.dateTo = this.dateTo
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.items = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
     dateFormat(val) {
      if(val == null){
        return null
      }
      var format = this.$store.state.session.DateTimeFormat
      format = format.substring(0, format.length - 5)
      return this.moment(val).format(format)
    },
    

    onOk (data) { },
    onCancel () { },    
    onShow () { },
    onHide () { },

    excel(IdDefaultReport){
      if(this.$store.state.session){
        this.form = {}
        if (this.$q.platform.is.ios){
          var windowReference = window.open()
        }
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.IdDefaultReport = IdDefaultReport

        this.form.DateFrom = this.dateFrom
        this.form.DateTo = this.dateTo

        axios.post(this.$apiGoUrl + '/excel/',
        qs.stringify(this.form),
        {
            responseType: 'blob', 
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then((response) => {
            const url = URL.createObjectURL(new Blob([response.data], {
                type: 'application/vnd.ms-excel'
            }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', "Yield.xlsx")
            document.body.appendChild(link)
            link.click()
        })
        .catch(e => {
          this.loading = false
          this.$q.notify('Something Wrong.')
          console.log(e);
        })
      }
    }

  },
  computed:{
    
  },
  mounted() {
    this.loadData() 
  },
  created () {
    eventBus.$on('yieldChange', (data) => {
      this.loadData()
    })
    eventBus.$on('Bus_ChangeLocale', (data) => {
      var cnr = 0
      this.columnHeaders.forEach(col => {
      this.columns[cnr].label = this.$t(col)
      cnr++
      })
    })
  },
  watch: {
    dateFrom: function (val) {
      this.loadData()
    },
    dateTo: function (val) {
      this.loadData()
    },
  },
}
</script>
<style scoped>
.content{
  padding: 10px;
}

</style>
